import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The farce of parliamentary election",
  "description": "",
  "published": "2008-09-22T00:00:00.000Z",
  "redirect_from": ["/blog/the-farce-of-parliamentary-election/swizec/68"],
  "categories": "food for thought",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Yesterday was election day and many people, I'm sure, rushed off to vote and make a difference. But did they really? Did they really make a difference? No they did not. Honestly, I don't know who won and I didn't vote either, neither of which makes any difference. As far as I know politics, and from what I've heard in the past few days, the same old people who've been in parliament for the last fifteen-ish years will continue being in there now. Sure they might be in different coalitions, anticoalitions and whathaveyou, but it's still the same old people.`}</p>
    <p>{`What people seem to forget about poltics is that politicians don't care about anyone but themselves. They're really in the entertainment business more than anything. They go to work every morning, they put up a show. Election comes, they put up a show. An important issue comes along, they put up a show. Something fails horribly, they cast someone down from their chair and put someone else in there, all for show. What these people really care about, the only thing they care about, is keeping collective control. They, as a company of two hundred something people, need to remain the ruling class. Who is apparently in charge at the moment and who is not is pretty much trivial as long as they collectively stay in charge.`}</p>
    <p>{`This is why I will never vote, because it just does not matter. A politician might some day come along who will rather spend money on important things than politicial campaigns and sway me into voting, but until then, for as long as politicians are willing to put up five days of events and concerts in city center instead of using said money to invest in helping people, I shall not vote nor believe in democracy.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      